import React from "react";
import styled from "styled-components";
import Iframe from "react-iframe";
import { Route, Switch, Redirect } from "react-router-dom";

const Bp = () => (
  <MapContainer>
    <MapFrame
    src="https://www.google.com/maps/embed?pb=!1m21!1m12!1m3!1d645.5853974029645!2d14.547407708291509!3d53.45065637607281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m6!3e0!4m0!4m3!3m2!1d53.4506981!2d14.5468526!5e1!3m2!1spl!2spl!4v1751008028608!5m2!1spl!2spl" 
    allowfullscreen="" 
    loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"
    />
  </MapContainer>
);

const Wb = () => (
  <MapContainer>
    <MapFrame
    src="https://www.google.com/maps/embed?pb=!1m21!1m12!1m3!1d645.5853974029645!2d14.547407708291509!3d53.45065637607281!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m6!3e0!4m0!4m3!3m2!1d53.4506981!2d14.5468526!5e1!3m2!1spl!2spl!4v1751008028608!5m2!1spl!2spl" 
    allowfullscreen="" 
    loading="lazy" 
    referrerpolicy="no-referrer-when-downgrade"
    />
  </MapContainer>
);

export const MapU = () => (
  <Switch>
    <Route path="/wykonawstwo_budowlane" component={Wb} />
    <Route path="/biuro_projektow" component={Bp} />
  </Switch>
);

const MapFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  shadow: 5px 5px 5px black;
`;

const MapContainer = styled.div`
  position: relative;
  align-content: center;
  width: auto;
  height: 320px;
  @media (max-width: 900px) {
    flex-direction: column;
    height: 160px;
  }
  margin-top: 60px;
`;
